const SCROLLED_POSITIONS_KEY = 'scrll_pos';
const RESTORE_SCROLL_POSITION_PARAM = 'scrll_res';
export class ScrollHandler {
    static #instance;
    constructor() { }
    static get instance() {
        if (!this.#instance)
            this.#instance = new ScrollHandler();
        return this.#instance;
    }
    saveScrollPosition(href, scrolled) {
        const scrolledPositions = this.getScrollPositions();
        scrolledPositions[href] = scrolled;
        sessionStorage.setItem(SCROLLED_POSITIONS_KEY, JSON.stringify(scrolledPositions));
    }
    getScrollPosition(href) {
        const scrolledPositions = JSON.parse(sessionStorage.getItem(SCROLLED_POSITIONS_KEY) ?? '{}');
        return scrolledPositions[href] ?? 0;
    }
    getScrollPositions() {
        return JSON.parse(sessionStorage.getItem(SCROLLED_POSITIONS_KEY) ?? '{}');
    }
    deleteScrollPosition(href) {
        const scrolledPositions = this.getScrollPositions();
        delete scrolledPositions[href];
        sessionStorage.setItem(SCROLLED_POSITIONS_KEY, JSON.stringify(scrolledPositions));
    }
    setScrollRestoration() {
        sessionStorage.setItem(RESTORE_SCROLL_POSITION_PARAM, 'true');
    }
    getScrollRestoration() {
        return sessionStorage.getItem(RESTORE_SCROLL_POSITION_PARAM) === 'true';
    }
    deleteScrollRestoration() {
        sessionStorage.removeItem(RESTORE_SCROLL_POSITION_PARAM);
    }
}
//# sourceMappingURL=scroll.handler.js.map